import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';


export default class Glossary extends Component {
    render() {
        return (
            <div>
                <h5 className="glossary-word">Glossary</h5>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">DAB</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            (Diameter above buttress) Diameter (cm) of the trunk/stem measured immediately above the root buttress. Referred to as ‘D’ and measured in metres in AS 4970-2009.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">DBH</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            (Diameter at breast height) Diameter (cm) of the trunk/stem measured at 1.4m above ground. For multi stem trees, refer to AS 4970-2009, Appendix A, Figure A1.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">Encroachment</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            Any work within the protection zone of a tree, including excavation, compacted fill and machine trenching.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">SRZ</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            (Structural root zone) An area around the base of a tree required for the tree’s stability in the ground. Woody root growth and soil cohesion in this area are necessary to hold the tree upright. Typically expressed as a radius in metres that defines a circle with the trunk/stem at its centre.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">TPZ</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            (Tree protection zone) An area set aside for the protection of a tree’s roots and crown to provide for the viability and stability of a tree to be retained where it is potentially subject to damage by development. Typically expressed as a radius in metres that defines a circle with the trunk/stem at its centre.
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
                <Row>
                    <Col sm={12} md={2} lg={2}>
                        <strong className="glossary-word">Work</strong>
                    </Col>
                    <Col>
                        <p className="glossary-text">
                            Any physical activity in relation to land that is specified by the determining authority (e.g. a local council).
                        </p>
                    </Col>
                    <Col xs={0} sm={0} md={2} lg={2}></Col>
                </Row>
            </div>
        );
    }
}